// Pricing configuration - safe to import in client components
export const PRICING = {
  CREDITS_PER_PACKAGE: 2,
  PRICE_IN_CENTS: 499, // $4.99
  PRICE_DISPLAY: '$4.99',
  CREDITS_PER_ANALYSIS: 1,
} as const;

